import { j as e } from "./jsx-runtime-721af1ab.js";
import { Show as r } from "@chakra-ui/react";
const m = ({ children: o }) => /* @__PURE__ */ e.jsx(r, { above: "md", children: o }), i = ({ children: o }) => /* @__PURE__ */ e.jsx(r, { below: "md", children: o });
export {
  m as D,
  i as M
};
